import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { ViewDefineComponent } from '../../components/view-define/view-define.component';
import { ElementDataRecordView, ElementService } from '../service/element.service';
import { OwnerByEnum, ownerElement } from '../../services/eleview/types/model';
import { LabelMockBackfaceService } from '../service/label-mock-backface.service';
import { IDisplayColumn } from '../../components/view-define/model';

@Component({
	selector: 'common-set-property-recordview',
	templateUrl: './set-property-recordview.component.html',
	styleUrls: ['./set-property-recordview.component.scss'],
	providers: [LabelMockBackfaceService]
})
export class SetPropertyRecordviewComponent implements OnInit {
	@HostBinding('class.set-property-recordview') hostClass = true;
	@ViewChild('viewDefine', { static: false })
	viewDefine: ViewDefineComponent;
	readonly ownerByEle = OwnerByEnum.ownerByEle;
	readonly ownerElement = ownerElement;
	public svr = this.elementSvr.data.recordview as ElementDataRecordView;
	constructor(public elementSvr: ElementService, public backface: LabelMockBackfaceService) {
		this.backface.isAdd = this.elementSvr.bill.isAdd();
		this.backface.recordViewData = this.svr;
	}

	ngOnInit() {
		this.svr.init();
	}
	viewModify(event: IDisplayColumn[]) {
		this.svr.Params.Columns = event;
	}
}
